export interface AscTimeOptions {
  label: string;
  value: string;
  disabled?: boolean;
}

export  const DEFAULT_TIME_OPTIONS: AscTimeOptions[] = [
  { label: "9:00 AM", value: "09:00" },
  { label: "9:30 AM", value: "09:30" },
  { label: "10:00 AM", value: "10:00" },
  { label: "10:30 AM", value: "10:30" },
  { label: "11:00 AM", value: "11:00" },
  { label: "11:30 PM", value: "11:30" },
  { label: "12:00 PM", value: "12:00" },
  { label: "12:30 PM", value: "12:30" },
  { label: "1:00 PM", value: "13:00" },
  { label: "1:30 PM", value: "13:30" },
  { label: "2:00 PM", value: "14:00" },
  { label: "2:30 PM", value: "14:30" },
  { label: "3:00 PM", value: "15:00" },
  { label: "3:30 PM", value: "15:30" },
  { label: "4:00 PM", value: "16:00" },
  { label: "4:30 PM", value: "16:30" },
  { label: "5:00 PM", value: "17:00" },
  { label: "5:30 PM", value: "17:30" },
  { label: "6:00 PM", value: "18:00" },
  { label: "6:30 PM", value: "18:30" },
  { label: "7:00 PM", value: "19:00" },
  { label: "7:30 PM", value: "19:30" },
  { label: "8:00 PM", value: "20:00" },
  { label: "8:30 PM", value: "20:30" },
  { label: "9:00 PM", value: "21:00" },
  { label: "9:30 PM", value: "21:30" },
];

export const DEFAULT_TIME_RANGES: AscTimeOptions[] = [
  { label: "9:00 - 9:30 AM", value: "09-00-09-30" },
  { label: "9:30 - 10:00 AM", value: "09-30-10-00" },
  { label: "10:00 - 10:30 AM", value: "10-00-10-30" },
  { label: "10:30 - 11:00 AM", value: "10-30-11-00" },
  { label: "11:00 - 11:30 AM", value: "11-00-11-30" },
  { label: "11:30 - 12:00 PM", value: "11-30-12-00" },
  { label: "12:00 - 12:30 PM", value: "12-00-12-30" },
  { label: "12:30 - 1:00 PM", value: "12-30-13-00" },
  { label: "1:00 - 1:30 PM", value: "13-00-13-30" },
  { label: "1:30 - 2:00 PM", value: "13-30-14-00" },
  { label: "2:00 - 2:30 PM", value: "14-00-14-30" },
  { label: "2:30 - 3:00 PM", value: "14-30-15-00" },
  { label: "3:00 - 3:30 PM", value: "15-00-15-30" },
  { label: "3:30 - 4:00 PM", value: "15-30-16-00" },
  { label: "4:00 - 4:30 PM", value: "16-00-16-30" },
  { label: "4:30 - 5:00 PM", value: "16-30-17-00" },
  { label: "5:00 - 5:30 PM", value: "17-00-17-30" },
  { label: "5:30 - 6:00 PM", value: "17-30-18-00" },
  { label: "6:00 - 6:30 PM", value: "18-00-18-30" },
  { label: "6:30 - 7:00 PM", value: "18-30-19-00" },
  { label: "7:00 - 7:30 PM", value: "19-00-19-30" },
  { label: "7:30 - 8:00 PM", value: "19-30-20-00" },
  { label: "8:00 - 8:30 PM", value: "20-00-20-30" },
  { label: "8:30 - 9:00 PM", value: "20-30-21-00" },
  { label: "9:00 - 9:30 PM", value: "21-00-21-30" },
  { label: "9:30 - 10:00 PM", value: "21-30-22-00" },
];